// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"c19663e2","281":"a86734be","546":"44802faf","854":"8de80d45","864":"404a8369","877":"6425920a","902":"89203f5a","913":"9f210499","979":"b2280caa","997":"fd3ce2af"}[chunkId] + ".chunk.js";
};